export const SET_TIME_TABLE = "SET_TIME_TABLE";
